import React, { Component } from 'react'
import { connect } from 'react-redux'
import { MDBRow, MDBCol, MDBListGroup,CardIcon,Icon,MDBCardImage ,MDBBadge,MDBListGroupItem, MDBCard,MDBCardTitle,MDBBtn, MDBCardFooter, MDBCardBody, MDBCardHeader, MDBIcon } from 'mdbreact'
import {Link} from 'react-router-dom';
import {firestoreConnect } from 'react-redux-firebase'
import {compose} from 'redux'
import {Redirect} from 'react-router-dom'

import { MDBCloseIcon } from 'mdbreact';
  
const  Customerdashboard = (props) =>{
    
       const { announcements ,auth } = props
       if(!auth.uid) return <Redirect to='/login' /> 
        return (
            <div>
                <section className="align-content-center teal p-5">
                 
                </section>
                <section className="p-5">
                    <MDBRow  className="mt-3">
                        <MDBCol md="8">
                            <MDBRow>
                                <MDBCol>
                                <MDBCard className="card-link  p-4 m-1 hoverable"  href="/milk" waves>
                                 <MDBRow>
                                     <MDBCol className="p-3 ml-2"  style={{
                                                    
                                                    borderRadius : "104px",
                                                    marginTop: "-3.13rem",
                                                    background : "#ffa726", 
                                           }}  > 
                                           <MDBIcon icon="bolt"
                                                    size="2x"
                                                    className=""

                                                    style={{padding:"20px"}}
                                                    />
                                                    
                                                    </MDBCol>

                                     <MDBCol> 
                                  <p style={{color:" #999999",
                                        margin: "0",
                                            marginTop: "0px",
                                            marginBottom: "0px",
                                        fontsize: "14px",
                                        marginTop: "0",
                                       
                                        marginBottom: "0"
                                        }}>Raise query</p></MDBCol>
                                 </MDBRow>

                                    <MDBCardFooter color="white" className="mt-3">
                                    <a color="elegant" href="/raiseQuery" className="red-text">Raise Query Now</a>
                                    </MDBCardFooter>
                                    </MDBCard>
                                </MDBCol>
                                <MDBCol>
                                <MDBCard className="card-link  p-4 m-1 hoverable"  href="/milk" waves>
                                 <MDBRow>
                                     <MDBCol className="p-3 ml-2"  style={{
                                                    
                                                    borderRadius : "104px",
                                                    marginTop: "-3.13rem",
                                                    background : "#43a047", 
                                           }}  > 
                                           <MDBIcon icon="eye"
                                                    size="2x"
                                                    className=""

                                                    style={{padding:"20px"}}
                                                    />
                                                    
                                                    </MDBCol>

                                     <MDBCol> 
                                  <p style={{color:" #999999",
                                        margin: "0",
                                            marginTop: "0px",
                                            marginBottom: "0px",
                                        fontsize: "14px",
                                        marginTop: "0",
                                       
                                        marginBottom: "0"
                                        }}>Raised query</p></MDBCol>
                                 </MDBRow>

                                    <MDBCardFooter color="white" className="mt-3">
                                    <a color="elegant" href="/viewQuery" className="red-text">View Queries Now</a>
                                    </MDBCardFooter>
                                    </MDBCard>
                                </MDBCol>
                                <MDBCol>
                                <MDBCard className="card-link  p-4 m-1 hoverable"  href="/milk" waves>
                                 <MDBRow>
                                     <MDBCol className="p-3 ml-2"  style={{
                                                    
                                                    borderRadius : "104px",
                                                    marginTop: "-3.13rem",
                                                    background : "#ff4444", 
                                           }}  > 
                                           <MDBIcon icon="external-link-alt"
                                                    size="2x"
                                                    className=""

                                                    style={{padding:"20px"}}
                                                    />
                                                    
                                                    </MDBCol>

                                     <MDBCol> 
                                  <p style={{color:" #999999",
                                        margin: "0",
                                            marginTop: "0px",
                                            marginBottom: "0px",
                                        fontsize: "14px",
                                        marginTop: "0",
                                       
                                        marginBottom: "0"
                                        }}> Feauted Products</p></MDBCol>
                                 </MDBRow>

                                    <MDBCardFooter color="white" className="mt-3">
                                    <a color="elegant" href="/raiseQuery" className="red-text">View Now</a>
                                    </MDBCardFooter>
                                    </MDBCard>
                                </MDBCol>
                                
                            </MDBRow>
                            <br  />
                          <MDBRow>
                              <h5 className="text-center">admin pages</h5><br />
                              <MDBBtn href="/QueryMainComponent" >Manage Complaints</MDBBtn>
                              <MDBBtn  href="/createAnnoucement">Create Annoucement</MDBBtn>
                          </MDBRow>
                        </MDBCol>
                        <MDBCol md="4" className="text-right">
                             <MDBRow >
                                 <MDBCard>
                                     <MDBCardHeader>
                                          VIEW ANNOUNCEMENTS
                                     </MDBCardHeader>
                                     <MDBCardBody>
                                     <div className="scrollbar scrollbar-primary scrollbar" style={{
                                   overflowY: "scroll",
                                   height:"150px",
    
                              }}>
                               <MDBListGroup style={{ width: "22rem" }}>
                               {announcements && announcements.map(announcement =>{
                                    return (
                                      
                                    
                                        <MDBListGroupItem hover href="#"  key={announcement.id}>
                                    <div className="d-flex w-100 justify-content-between">
                                        <h5 className="mb-1">{announcement.title}</h5>
                                        <small>{announcement.time}</small>
                                    </div>
                                    <p className="mb-1">{announcement.content}</p>
                                        <MDBBadge color="primary"
                                               pill>view</MDBBadge>
                                    </MDBListGroupItem>
                                       
                                    
                                    )
                                })}
                                    
                        
                               </MDBListGroup>
                                     
                              </div>
    
                                     </MDBCardBody>
                                 </MDBCard>
                             
                             </MDBRow>
                             <br />
                             <MDBRow>
                                    <MDBCard className="card-link  hoverable"  href="/milk" waves>
                                        <MDBCardHeader>
                                        VIEW MESSAGES
                                        </MDBCardHeader>
                                        <MDBCardBody>
                                        <MDBCardTitle tag="h6" className="">VIEW MESSAGES</MDBCardTitle>
                                        </MDBCardBody>
                                   
                                    </MDBCard>
                             </MDBRow>
                        </MDBCol>
                    </MDBRow>
                </section>
            </div>
        )
    

   
}
const mapStateToProps = (state) => {
    console.log(state)
    return{
        auth : state.firebase.auth,
        announcements : state.firestore.ordered.projects
    } 
}

const mapDispatchToProps = {
    
}

export default compose(connect(mapStateToProps),firestoreConnect([
    {
        collection : 'projects'
    }
]))(Customerdashboard)